import React from 'react';
import {Callout, FormGroup, InputGroup, Switch} from '@blueprintjs/core';
import {IconNames} from '@blueprintjs/icons';

interface HTMLTableExportProps {
  align?: string;
  border?: string;
  cellpadding?: string;
  cellspacing?: string;
  width?: string;
  transpose?: boolean;
  onChange: (key: string) => (value: any) => void;
}

export const HTMLTableExport = ({
  align = '',
  border = '',
  cellpadding = '',
  cellspacing = '',
  width = '',
  transpose = false,
  onChange,
}: HTMLTableExportProps) => {
  const onInputChange = (key: string) => (e: any) => {
    onChange(key)(e.target.value);
  }

  const onSwitchChange = (key: string) => (e: any) => {
    onChange(key)(e.target.checked);
  }

  return (
    <>
      <Callout icon={IconNames.INFO_SIGN}>
        Only applicable if selected Destination Type is "Email".
      </Callout>
      <FormGroup label="Transpose Results?" inline={true}>
        <Switch
          defaultChecked={transpose}
          onChange={onSwitchChange('transpose')}
        />
      </FormGroup>
      <FormGroup inline={true} label="Border">
        <InputGroup
          defaultValue={border}
          autoComplete="off"
          onChange={onInputChange('border')}
          placeholder="1"
        />
      </FormGroup>
      <FormGroup inline={true} label="Cellspacing">
        <InputGroup
          defaultValue={cellspacing}
          autoComplete="off"
          onChange={onInputChange('cellspacing')}
          placeholder="1"
        />
      </FormGroup>
      <FormGroup inline={true} label="Cellpadding">
        <InputGroup
          defaultValue={cellpadding}
          autoComplete="off"
          onChange={onInputChange('cellpadding')}
          placeholder="1"
        />
      </FormGroup>
      <FormGroup inline={true} label="Width">
        <InputGroup
          defaultValue={width}
          autoComplete="off"
          onChange={onInputChange('width')}
          placeholder="200"
        />
      </FormGroup>
      <FormGroup inline={true} label="Align">
        <InputGroup
          defaultValue={align}
          autoComplete="off"
          onChange={onInputChange('align')}
          placeholder="left"
        />
      </FormGroup>
    </>
  );
};

export default HTMLTableExport;
